import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  margin-left: 10px;
  cursor: pointer;
  position: relative;
`;

export const DownloadButton = styled.a`
  &.disabled {
    pointer-events: none;
    opacity: 0.5;
  }
`;

export const DownloadIcon = styled.i`
  font-size: 22px !important;
  margin-top: 2px;
`;
